import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { TranslatePipe } from '../../../pipes/translate.pipe';

@Component({
  selector: 'app-matchmaking-how-it-works',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule, TranslatePipe],
  templateUrl: './matchmaking-how-it-works.component.html',
  styleUrl: './matchmaking-how-it-works.component.scss',
})
export class MatchmakingHowItWorksComponent {
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  close(): void {
    this.visible = false;
    this.visibleChange.emit(false);
  }
}
